import React from 'react'
import { CustomGoogleMap, ResponseDisplayWrapper } from '../components';

function ResponseDetailContainer({ response }) {

  const fields = response.form.fields;

  // Helper function to check if answer is empty
  const isEmpty = (value) => {
    return value == null || value == undefined || value.toString().trim() === '';
  };

  // Component for empty state message
  const EmptyState = ({ message }) => (
    <p className="text-gray-400 italic">{message}</p>
  );

  return (
    <div>

      {fields.map((field, index) => {

        let answer = response.responseObject[field.name];

        switch (field.key) {

          case "text":
          case "number":
          case "radio":
          case "checkbox":
            return <ResponseDisplayWrapper key={index} number={index + 1} prompt={field.prompt}>
              {!isEmpty(answer) ? (
                <h1>{answer}</h1>
              ) : (
                <EmptyState message="No answer provided" />
              )}
            </ResponseDisplayWrapper>
          case "image":
            return <ResponseDisplayWrapper key={index} number={index + 1} prompt={field.prompt}>
              {!isEmpty(answer) ? (
                <div className='w-1/2 max-w-[18rem]'>
                  <img src={answer} alt="image" className=' w-full' />
                </div>
              ) : (
                <EmptyState message="No image provided" />
              )}
            </ResponseDisplayWrapper>

          case "gps":
            return <ResponseDisplayWrapper key={index} number={index + 1} prompt={field.prompt}>
              {!isEmpty(answer) ? (
                <div className='w-1/2  h-60'>
                  <CustomGoogleMap places={[{
                    lat: answer.split(",")[0],
                    lng: answer.split(",")[1],
                    markerData: {
                      responseId: response._id,
                      formId: response.form_id,
                      form: response.form.title,
                      responseDate: response.createdAt,
                      agent: `${response.filledBy.firstName} ${response.filledBy.lastName}`
                    }
                  }]} />
                </div>
              ) : (
                <EmptyState message="No location provided" />
              )}
            </ResponseDisplayWrapper>




        }

      })}

    </div>
  )
}

export default ResponseDetailContainer